module.exports = __webpack_public_path__ + "img/about01.e5db951a.svg";